import { Collapse, CollapseProps, Icon } from "@blueprintjs/core"
import { useUncontrolled } from "@mantine/hooks"
import React from "react"
import classNames from "utils/classNames"
type CollapseCardType = CollapseProps & {
  children?: React.ReactNode
  title?: React.ReactNode
  icon?: any
  headerClassName?: any
  onChange?: (value: boolean) => void
}
const CollapseCard = ({
  children,
  icon,
  title,
  isOpen,
  headerClassName,
  className,
  onChange,
  ...props
}: CollapseCardType) => {
  const [_isOpen, handleChange] = useUncontrolled({
    value: isOpen,
    defaultValue: false,
    onChange: onChange,
    finalValue: false,
  })

  return (
    <div
      className={classNames(
        "bg-gray-100 rounded-md shadow-sm overflow-hidden",
        className
      )}
    >
      <div
        className={classNames(
          "flex justify-between items-center p-2 transition-colors duration-200 hover:opacity-80 cursor-pointer",
          _isOpen && "bg-blue-100",
          headerClassName
        )}
        onClick={() => handleChange(!_isOpen)}
      >
        <span>
          {icon} {title}
        </span>{" "}
        <Icon icon={_isOpen ? "chevron-down" : "chevron-up"} />
      </div>
      <Collapse isOpen={_isOpen} {...props}>
        {children}
      </Collapse>
    </div>
  )
}

export default CollapseCard
